<template>
    <div class="alt-checkbox">
        <a class="alt-checkbox__box" href="#"
            @click.prevent="toggle"
            v-bind:class="{ 'alt-checkbox__box--checked' : this.value }"></a>

        <span class="alt-checkbox__text">
            <slot></slot>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        initialvalue: {
            default: () => 0
        }
    },

    data() {
        return {
            value: false
        }
    },

    methods: {
        toggle() {
            this.value = !this.value;
            this.$emit('box-checked', this.value);
        }
    },

    created() {

    },

    mounted() {
        this.value = this.initialvalue;
    }
}
</script>

<style lang="scss">
    .alt-checkbox {
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;

        &__box {
            display: inline-block;
            width: 20px;
            height: 20px;
            border-radius: 9999px;
            border: 1px solid $color-light-blue;
            margin-right: 10px;
            transition: 0.2s ease-in;
            flex-shrink: 0;

            &--checked {
                background-color: $color-gold;
                border: 1px solid $color-gold;
            }
        }

        &__check {

        }

        &__text {
            @include font-small;
        }
    }
</style>